import type { FormFieldOptionDetails } from "@tellescope/types-models";
import { resolveFormTranslation, type FormTranslationMap } from "./resolve-form-translation";

/** An option's English value paired with the text shown for it. */
export interface TranslatedOptionDetail extends FormFieldOptionDetails {
  /** What the enduser reads. Display only — never store or compare this. */
  label: string;
  /** The translated `description`, or the authored one when untranslated. */
  translatedDescription?: string;
}

/**
 * Pairs each option with its translated label while leaving `option` — the value stored as the answer
 * and compared by conditional logic and scoring — in the authored English.
 *
 * Keeping the two apart is what makes translation display-only. Translating `option` itself would
 * write translated text into the submitted response, so a Spanish enduser's answer would no longer
 * match the English value a Score branch or `showCondition` tests against.
 *
 * Order and count are preserved, so index-based logic is unaffected.
 */
export const translateFieldOptionLabels = (
  optionDetails: FormFieldOptionDetails[],
  translations: FormTranslationMap | undefined
): TranslatedOptionDetail[] =>
  optionDetails.map((detail) => ({
    ...detail,
    label: resolveFormTranslation(detail.option, translations) ?? detail.option,
    translatedDescription: resolveFormTranslation(detail.description, translations),
  }));
